/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string, array, shape, bool, func,
} from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Caret from '@material-ui/icons/ArrowForwardIos';
import { useUIDSeed } from 'react-uid';
import ReactMarkdown from 'react-markdown';
import { Container } from '@material-ui/core';
import generateValidCss from '../../../../helpers/contentstack/generateValidCss';
import Copy from '../../Copy';
import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
/*
    TODO: Create ability to add sashes and dot-whacks.
          Create mobile version
          Define # per row (maybe unnecessary)
*/

const styles = (theme) => ({
    nUp: {
        width: '95%',
        maxWidth: '1400px',
        margin: theme.palette.nup?.margin,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        '& *:focus': {
            outline: 'none',
        },
        '@media screen and (max-width: 600px)': {
            display: 'block',
            '& > [anchor]': {
                display: 'block',
                margin: '0 auto 30px',
                width: '100% !important',
                '& [message]': {
                    width: '90%',
                    '& *': {
                        fontSize: '1em',
                    },
                },
            },
        },
    },
    planUp: {
        backgroundColor: theme.palette.desktopBgFooter,
        width: '95%',
        maxWidth: '1400px',
        margin: theme.palette.nup?.margin,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        '& *:focus': {
            outline: 'none',
        },
        '@media screen and (max-width: 600px)': {
            display: 'block',
            '& > [anchor]': {
                display: 'block',
                margin: '0 auto 30px',
                width: '100% !important',
                '& [message]': {
                    width: '90%',
                    '& *': {
                        fontSize: '1em',
                    },
                },
            },
        },
    },
    fullWidth: {
        maxWidth: '100%',
        width: '100%',
    },
    header: theme.palette.nup?.header,
    panel: {
        height: 'auto',
        textDecoration: 'none',
        backgroundSize: 'cover',
        textAlign: 'center', // TODO: needs to be adjustable in CMS> HD is not centered
        display: 'flex',
        flexDirection: 'column',
        '@media screen and (max-width: 1000px)': {
            '& > div': {
                height: '30vw',
            },
            '& [message]': {
                width: '100%',
                '& *': {
                    fontSize: '16px',
                },
            },
        },

    },
    nupContent: {

    },
    root: {
        boxSizing: 'border-box',
        padding: theme.spacing(3, 0, 0, 0),
    },
    containerLink: {
        textDecoration: 'none',
    },
    imageContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        transition: 'all .3s',
        '&:hover': {
            opacity: '.94',
            '& button': {
                textDecoration: 'underline',
            },
        },
        '& p': {
            margin: '0',
        },
    },
    plaImageContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        transition: 'all .3s',
        '&:hover': {
            opacity: '.94',
            '& button': {
                textDecoration: 'none',
            },
        },
        '& p': {
            margin: '0',
        },
    },
    imageFixedWidth: {
        maxWidth: '240px',
    },
    messageWrapper: {
        alignSelf: 'flex-end',
        padding: '10px 0',
        width: '100%',
        '& u': {
            fontSize: '0.7em',
        },
    },
    plaMessageWrapper: {
        display: 'flex',
        marginBottom: '-65px',
        backgroundColor: 'unset !important',
        textAlign: 'left',
        alignSelf: 'flex-end',
        padding: '10px 0',
        width: '100%',
        '& u': {
            fontSize: '0.7em',
        },
    },
    messageWrapperTab: {
        width: '80%',
        margin: '0 auto',
        padding: '10px',
        '& u': {
            fontSize: '0.7em',
        },
    },
    cta: {
        boxSizing: 'border-box',
        display: 'block',
        margin: '0 auto',
        fontSize: '18px',
        fontWeight: '800',
        borderRadius: '2px',
    },
    circleMask: {
        borderRadius: '50%',
    },
    btnStyle: {
        fontSize: '25px',
        marginTop: '14px',
        fontWeight: 'normal',
        lineHeight: '38px',
        letterSpacing: '1.25px',
        textTransform: 'capitalize',
        textDecoration: 'none',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    titleStyle: {
        display: 'block',
        fontSize: '30px',
        textAlign: 'center',
        fontFamily: 'BebasNeue',
        fontWeight: 'normal',
        lineHeight: '32px',
        marginBottom: '45px',
        letterSpacing: '1.8px',
        paddingTop: '40px',
    },
    Standard: theme.palette.nup?.Standard,
    Medium: theme.palette.nup?.Medium,
    Small: theme.palette.nup?.Small,
});

const elementWidth = (data) => {
    /*
     * @intention Base element widths on number of rows.
     * E.g. 10 items across 1 row = 10% width (+/-) each
     * 10 items across 2 rows = 20% width (+/-) each
     * if 1 row and two elements, create narrower gap between both than ususal.
     * Also adds bottom margins for multiple rows
     * @param {obj} - the entire data prop
     * @return {obj} - e.g. { width: value }
     */

    const elementCount = data?.reference?.[0]?.entry?.length || 0;
    const rowCount = data?.reference?.[0].styles.rows || 1;
    let widthValue = 0;
    let rowMargin = '';

    if (rowCount > 1) { // more than one row, distribute elements to rows by making widths relative to row count
        widthValue = `${98 / (elementCount / rowCount)}%`;
        rowMargin = '40px';
    }

    if (rowCount === 1) { // only one row, make widths even
        widthValue = `${98 / elementCount}%`;
    }

    if (elementCount === 2) { // only two elements, make gap small
        widthValue = `${99.5 / elementCount}%`;
    }

    if (elementCount === 2) { // only two elements, make gap small
        widthValue = `${99.5 / elementCount}%`;
    }

    return { width: widthValue, marginBottom: rowMargin };
};

const fontFamilyParsed = (fontData) => {
    if (!fontData) return '';
    const fontArr = fontData.split(':');
    if (fontArr?.[1]) {
        return fontArr[1].replace(';', '');
    }
    return '';
};
const detailsAsObj = (promo) => {
    const data = [
        {
            details_link: {
                details_link: promo,
                presentation: 'Single Line',
            },
        },
    ];
    return data;
};
const NUpSimple = ({
    classes, headingAlignment, data, isBot, track, brand,
}) => {
    if (data.reference?.[0]) {
        const nup = data.reference[0];
        const itemList = nup.entry;
        const seed = useUIDSeed();
        let messageWrapper = (brand?.code === 'PLA') ? classes.plaMessageWrapper : classes.messageWrapper;
        if (nup.styles.message_bg_style === 'Tab') { messageWrapper = classes.messageWrapperTab; }
        const caretIcon = <Caret>content</Caret>;
        const arrowPLAIcon = (
            <img
                className="arrow"
                src="https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltaf23a429ab1fcc5a/634424651882bd10b7915839/cta-icon2x-4b14996f471bc2b23c01c5d8d54a1888.png"
                alt="arrow-icon"
                style={{
                    maxWidth: '16px',
                    height: '10px',
                    paddingLeft: '3%',
                    verticalAlight: 'middle',
                }}
            />
        );
        const buttonIcon = (brand?.code === 'PLA') ? arrowPLAIcon : caretIcon;
        const arrowBtnStyle = (brand?.code === 'PLA') ? classes.btnStyle : '';
        const imageContainerStyle = (brand?.code === 'PLA') ? classes.plaImageContainer : classes.imageContainer;
        const nUpStyle = (brand?.code === 'PLA') ? classes.planUp : classes.nUp;
        const bannerBody = () => {
            const bannerBodyUI =  (
                <div className={`${nUpStyle} ${itemList.full_width ? classes.fullWidth : ''}`} data-container="Nup Simple">
                    {itemList.heading ? <h3 className={classes.header} style={{ textAlign: headingAlignment }}>{itemList.heading}</h3> : null}
                    {
                        itemList.map((panelItem) => (
                            <>
                                <Link
                                    key={seed(panelItem)}
                                    anchor=""
                                    to={panelItem.linking?.link?.href}
                                    title={panelItem.linking?.link?.title}
                                    className={classes.panel}
                                    style={elementWidth(data)}
                                    onClick={() => {
                                        track({
                                            eventCategory: panelItem?.linking?.tracking_event_category || '',
                                            eventAction: panelItem?.linking?.tracking_event_action || '',
                                            eventLabel: panelItem?.linking?.tracking_event_label || '',
                                            eventName: 'feature_interaction', // Requird for GA4 feature_click
                                        });
                                    }}
                                    target={panelItem.linking?.link?.href?.indexOf('greenhouse') > -1 ? '_blank' : ''}
                                >
                                    { panelItem.background_image
                                    /* If a backgroud image is provided, it will render as default product tile
                                    else it will render a div of provided dimension / presentation style */
                                        ? (
                                            <>
                                                <div
                                                    className={imageContainerStyle}
                                                    style={{
                                                        backgroundImage: `url(${panelItem.background_image.url})`,
                                                        backgroundSize: 'cover',
                                                        minHeight: '440px',
                                                        backgroundPositionX: 'center',
                                                    }}
                                                >
                                                    {isBot && <img src={panelItem.background_image.url} alt={panelItem.background_image.title} isBot="true" />}
                                                    <div
                                                        className={messageWrapper}
                                                        message=""
                                                        style={{
                                                            backgroundColor: `${nup.styles.message_background_color?.color}`,
                                                            backgroundPositionY: 'top',
                                                            opacity: '.9',
                                                            fontSize: `${nup.styles?.font_size}em`,
                                                            minHeight: `${nup.styles?.message_background_height}px`,
                                                            fontFamily: fontFamilyParsed(nup.styles?.copy_font),
                                                            color: nup.styles?.copy_color?.color,
                                                        }}
                                                    >
                                                        {panelItem.copy && panelItem.copy.map((k) => <ReactMarkdown source={k}  />)}
                                                        {panelItem.details_link && <Copy data={detailsAsObj(panelItem.details_link)} />}
                                                        {panelItem.cta_copy && (
                                                            <Button
                                                                className={arrowBtnStyle}
                                                                text
                                                                endIcon={buttonIcon}
                                                                style={{
                                                                    fontFamily: fontFamilyParsed(nup.styles?.copy_font),
                                                                }}
                                                            >{panelItem.cta_copy}
                                                            </Button>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                            /* Added Copy components instead of manual switch case
                                            to avoid code repetition and to add more functionality to n-up panel.
                                            We can use Panel component directly but background image logic has not been implemented in it yet */
                                        )
                                        : (
                                            <div className={classes[data?.reference[0]?.presentation_style]} style={generateValidCss(panelItem.container_attributes, true)}>
                                                <Copy data={panelItem.message_collection} />
                                            </div>
                                        )}
                                </Link>
                            </>
                        ))
                    }
                </div>
            );
            return bannerBodyUI;
        };
        return (
            <>
                { brand?.code === 'PLA'
                    ? (
                    // eslint-disable-next-line react/jsx-wrap-multilines
                        <Container>
                            <h2 className={classes.titleStyle}>{nup?.title}</h2>
                            {bannerBody()}
                        </Container>)
                    : bannerBody() }
            </>
        );
    }
    return <>n_up not loaded correctly</>;
};

NUpSimple.propTypes = {
    data: shape({
        entry: shape({
            linking: object,
            copy: array,
            cta_copy: array,
            background_image: object,
            background_image_mobile: object,
        }).isRequired,
        styles: object,
    }).isRequired,
    classes: object.isRequired,
    headingAlignment: string.isRequired,
    isBot: bool.isRequired,
    track: func.isRequired,
    brand: shape({
        code: string,
    }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    track: bindActionCreators(trackEvent, dispatch),
});

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(NUpSimple));
